export default {
  myDevices: {
    myDeviceRemoved: 'Device removed',
    myDeviceUpdated: 'Device updated',
    myDeviceAdded: 'Device added',
    myDevices: 'Devices',
    myDevice: 'Device',
    refreshRate: 'Refresh rate',
    myDeviceCode: 'Device code',
    warningConfig: 'Warning config',
    emergencyCallAlarm: 'Emergency call alarm',
    fallingAlarm: 'Falling alarm',
    heartPulseAlarm: 'Heart pulse alarm',
    heartRateAlarm: 'Heart rate alarm',
    pulseRateAlarm: 'Pulse rate alarm',
    spo2Alarm: 'Spo2 alarm',
    temperatureAlarm: 'Temperature alarm'
  }
}
